/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatrixCareExistingPatient
 */
export interface MatrixCareExistingPatient {
    /**
     * 
     */
    patient_id: string;
    /**
     * 
     */
    patient_demo_id?: string;
    /**
     * 
     */
    admission_id?: string;
    /**
     * MatrixCare MRN, if assigned.
     */
    medical_record?: string;
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    last_name?: string;
    /**
     * 
     */
    middle_name?: string;
    /**
     * 
     */
    full_name?: string;
    /**
     * ISO YYYY-MM-DD.
     */
    date_of_birth?: string;
    /**
     * NNN-NN-NNNN if MatrixCare has it; null otherwise.
     */
    formatted_ssn?: string;
    /**
     * 
     */
    gender?: string;
    /**
     * 
     */
    city?: string;
    /**
     * e.g., "New Referral", "Admitted", "Rejected", "Discharge Pending".
     */
    admission_status?: string;
    /**
     * 
     */
    admission_status_effective_date?: string;
    /**
     * 
     */
    previous_admission_count: number;
    /**
     * 
     */
    business_unit_name?: string;
    /**
     * MatrixCare-formatted display line, e.g. "Tester123, Trev (MRN 9911020) - New Referral (07/15/2026)".
     */
    formatted_summary?: string;
}

/**
 * Check if a given object implements the MatrixCareExistingPatient interface.
 */
export function instanceOfMatrixCareExistingPatient(value: object): value is MatrixCareExistingPatient {
    if (!('patient_id' in value) || value['patient_id'] === undefined) return false;
    if (!('previous_admission_count' in value) || value['previous_admission_count'] === undefined) return false;
    return true;
}

export function MatrixCareExistingPatientFromJSON(json: any): MatrixCareExistingPatient {
    return MatrixCareExistingPatientFromJSONTyped(json, false);
}

export function MatrixCareExistingPatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCareExistingPatient {
    if (json == null) {
        return json;
    }
    return {
        
        'patient_id': json['patient_id'],
        'patient_demo_id': json['patient_demo_id'] == null ? undefined : json['patient_demo_id'],
        'admission_id': json['admission_id'] == null ? undefined : json['admission_id'],
        'medical_record': json['medical_record'] == null ? undefined : json['medical_record'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'middle_name': json['middle_name'] == null ? undefined : json['middle_name'],
        'full_name': json['full_name'] == null ? undefined : json['full_name'],
        'date_of_birth': json['date_of_birth'] == null ? undefined : json['date_of_birth'],
        'formatted_ssn': json['formatted_ssn'] == null ? undefined : json['formatted_ssn'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'city': json['city'] == null ? undefined : json['city'],
        'admission_status': json['admission_status'] == null ? undefined : json['admission_status'],
        'admission_status_effective_date': json['admission_status_effective_date'] == null ? undefined : json['admission_status_effective_date'],
        'previous_admission_count': json['previous_admission_count'],
        'business_unit_name': json['business_unit_name'] == null ? undefined : json['business_unit_name'],
        'formatted_summary': json['formatted_summary'] == null ? undefined : json['formatted_summary'],
    };
}

export function MatrixCareExistingPatientToJSON(json: any): MatrixCareExistingPatient {
    return MatrixCareExistingPatientToJSONTyped(json, false);
}

export function MatrixCareExistingPatientToJSONTyped(value?: MatrixCareExistingPatient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patient_id': value['patient_id'],
        'patient_demo_id': value['patient_demo_id'],
        'admission_id': value['admission_id'],
        'medical_record': value['medical_record'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'middle_name': value['middle_name'],
        'full_name': value['full_name'],
        'date_of_birth': value['date_of_birth'],
        'formatted_ssn': value['formatted_ssn'],
        'gender': value['gender'],
        'city': value['city'],
        'admission_status': value['admission_status'],
        'admission_status_effective_date': value['admission_status_effective_date'],
        'previous_admission_count': value['previous_admission_count'],
        'business_unit_name': value['business_unit_name'],
        'formatted_summary': value['formatted_summary'],
    };
}

